// "Client Since" shown on the profile is clientSince, else the record's
// creation date. Edit forms must prefill the same value, or saving an
// unrelated field looks like it cleared/changed the date.

type ClientDates = { clientSince?: string | Date | null; createdAt?: string | Date | null };

/** YYYY-MM-DD for <input type="date">, matching the displayed Client Since. */
export function clientSinceInputValue(client: ClientDates): string {
  const raw = client.clientSince || client.createdAt;
  if (!raw) return "";
  const d = new Date(raw);
  return Number.isNaN(d.getTime()) ? "" : d.toISOString().split("T")[0];
}
